/**
 * フィールドパレット - フィールドタイプを選択するためのサイドバー
 */

import { FIELD_TYPES, type FieldType } from '../../types/formBuilder'

interface FieldPaletteProps {
  onAddField: (fieldType: FieldType) => void
}

export function FieldPalette({ onAddField }: FieldPaletteProps) {
  return (
    <div style={{
      backgroundColor: 'white',
      border: '1px solid #e5e7eb',
      borderRadius: '0.5rem',
      padding: '1rem'
    }}>
      <div style={{ marginBottom: '1rem' }}>
        <h3 style={{
          fontSize: '0.875rem',
          fontWeight: 600,
          color: '#374151',
          marginBottom: '0.25rem'
        }}>フィールドパレット</h3>
        <p style={{
          fontSize: '0.75rem',
          color: '#6b7280'
        }}>フィールドをクリックしてフォームに追加</p>
      </div>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '0.5rem'
      }}>
        {FIELD_TYPES.map((fieldType) => {
          const Icon = fieldType.icon
          return (
            <button
              key={fieldType.type}
              onClick={() => onAddField(fieldType.type)}
              style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: '0.75rem',
                padding: '0.75rem',
                backgroundColor: 'white',
                border: '1px solid #e5e7eb',
                borderRadius: '0.5rem',
                fontSize: '0.875rem',
                textAlign: 'left',
                cursor: 'pointer',
                transition: 'all 0.15s'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = '#d1d5db'
                e.currentTarget.style.backgroundColor = '#f9fafb'
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = '#e5e7eb'
                e.currentTarget.style.backgroundColor = 'white'
              }}
            >
              <div style={{
                width: '2rem',
                height: '2rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#f3f4f6',
                borderRadius: '0.375rem',
                flexShrink: 0
              }}>
                <Icon size={18} strokeWidth={2} color="#6b7280" />
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{
                  fontWeight: 500,
                  color: '#374151',
                  marginBottom: '0.125rem'
                }}>
                  {fieldType.label}
                </div>
                <div style={{
                  fontSize: '0.75rem',
                  color: '#6b7280',
                  lineHeight: '1.25'
                }}>
                  {fieldType.description}
                </div>
              </div>
            </button>
          )
        })}
      </div>
    </div>
  )
}
